<template>
  <div
    class="mb-2 flex flex-row flex-wrap items-center justify-between gap-2 rounded border border-blue-100/50 px-4 py-3 text-sm text-blue-800">
    <div class="flex items-center gap-3">
      <div class="custom-icon shrink-0 text-blue-600">
        <IconMyAccount />
      </div>
      <span>
        Participant concerné :
        <strong class="font-semibold"
          >{{ props.nom }} {{ props.prenom }}</strong
        >
      </span>
    </div>
    <div>
      <div
        v-if="props.telephone"
        class="flex items-center gap-3">
        <span class="custom-icon text-green-600">
          <IconSmartphone />
        </span>

        <span class="font-medium">{{ props.telephone }}</span>
        <span
          class="rounded bg-green-100 px-2.5 py-1 font-bold tracking-wider text-green-600"
          >RENSEIGNÉ</span
        >
      </div>
      <div
        v-else
        class="flex flex-col items-start gap-1.5 sm:items-end">
        <div class="flex items-center gap-2">
          <span class="custom-icon text-jinius-red">
            <IconNoSmartphone />
          </span>
          <span class="font-bold text-jinius-red">Mobile manquant</span>
        </div>
        <span
          class="max-w-[320px] italic leading-snug text-jinius-red sm:text-right">
          Veuillez contacter le participant pour qu'il renseigne son numéro sur
          la page <strong>Mes informations personnelles</strong> de son espace
          Jinius.
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import IconMyAccount from '@/assets/img/refonte/icons/users/icon-my-account.svg?component';
  import IconSmartphone from '@/assets/img/refonte/icons/information/icon-smartphone.svg?component';
  import IconNoSmartphone from '@/assets/img/refonte/icons/information/icon-no-smartphone.svg?component';

  const props = withDefaults(
    defineProps<{
      nom: string;
      prenom: string;
      telephone?: string;
    }>(),
    {}
  );
</script>

<style lang="scss" scoped>
  .custom-icon {
    @apply flex shrink-0 items-center justify-center;
    width: 16px;
    height: 16px;

    :deep(svg) {
      width: 16px;
      height: 16px;
    }
  }
</style>
